import { render, staticRenderFns } from "./IrrigationSubmissionForm.vue?vue&type=template&id=0846929d"
import script from "./IrrigationSubmissionForm.vue?vue&type=script&lang=js"
export * from "./IrrigationSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports